import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

function useGetAllUsers() {
  const { t } = useTranslation('global');
  const { showApiError } = useGlobalContext();
  const { security: securityApi } = useApiContext();

  const { data: users, isLoading } = useQuery(
    [KEYS.security.getAllUsers()],
    () => securityApi.accounts.GetAllUser(),
    {
      select: ({ data }) => data?.data || [],
      onError: (error) =>
        showApiError(error, t('common.commonMessages.genericRequestError')),
      refetchOnWindowFocus: false
    }
  );

  return {
    users,
    isLoading
  };
}

export default useGetAllUsers;
